import { render, staticRenderFns } from "./updateView.vue?vue&type=template&id=999a6fcc"
import script from "./updateView.vue?vue&type=script&setup=true&lang=ts"
export * from "./updateView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports